<template>
  <vs-popup id="popupRiskDecision" title="<표 3-1> 위험성 결정(가능성× 중대성) : 중요위험(허용가능/불가능) 여부" :active.sync="popupActiveSync">
    <div class="p-4">
      <table>
        <colgroup>
          <col width="95"/>
          <col width="95"/>
          <col />
          <col />
          <col />
          <col />
          <col />
        </colgroup>
        <thead>
        <tr>
          <th colspan="2" style="text-align: right; border-bottom: none; padding-top: 7px;">중대성</th>
          <th rowspan="3">1</th>
          <th rowspan="3">2</th>
          <th rowspan="3">3</th>
          <th rowspan="3">4</th>
          <th rowspan="3">5</th>
        </tr>
        <tr>
          <th colspan="2" style="text-align: start; border-top: none; border-bottom: none;">(강도)</th>
        </tr>
        <tr>
          <th colspan="2" style="text-align: start; border-top: none; padding-bottom: 7px;">가능성(빈도)</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <th colspan="2">1</th>
          <td>1(A+)</td>
          <td>2(A+)</td>
          <td>3(A+)</td>
          <td>4(A0)</td>
          <td>5(A0)</td>
        </tr>
        <tr>
          <th colspan="2">2</th>
          <td>2(A+)</td>
          <td>4(A0)</td>
          <td>6(A0)</td>
          <td>8(B+)</td>
          <td class="orange">10(B0)</td>
        </tr>
        <tr>
          <th colspan="2">3</th>
          <td>3(A+)</td>
          <td>6(A0)</td>
          <td>9(B+)</td>
          <td class="orange">12(B0)</td>
          <td class="orange">15(C+)</td>
        </tr>
        <tr>
          <th colspan="2">4</th>
          <td>4(A0)</td>
          <td>8(B+)</td>
          <td class="orange">12(B0)</td>
          <td class="orange">16(C+)</td>
          <td class="red">20(C0)</td>
        </tr>
        <tr>
          <th colspan="2">5</th>
          <td class="orange">5(A0)</td>
          <td class="orange">10(B0)</td>
          <td class="orange">15(C+)</td>
          <td class="red">20(C0)</td>
          <td class="red">25(D)</td>
        </tr>
        </tbody>
      </table>

      <div class="mt-4 grid" style="grid-template-columns: 130px 188px 130px 188px; justify-content: right;">
        <div class="mark orange"></div>
        <div class="mark">중요위험(허용가능)</div>
        <div class="mark red"></div>
        <div class="mark">중요위험(허용불가능)</div>
      </div>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'PopupRiskDksteelDecision',
  props: {
    value: Boolean,
  },
  components: {
  },
  computed: {
    popupActiveSync: {
      get () {
        return this.value
      },
      set () {
        this.handleCloseSelf()
      }
    }
  },
  methods: {
    handleCloseSelf () {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    border: 1px solid #cdcdcd;
    text-align: center;
    font-size: 14px;
    color: #3c3c3c;
    font-weight: 500;
  }

  thead {
    th {
      background: #f9f9f9;
      padding: 2px 14px;
    }
  }
  tbody {
    th {
      background: #f9f9f9;
      padding: 14px;
      line-height: 20px;
    }
    td {
      padding: 14px;
      line-height: 20px;
    }
  }
}

.orange {
  background-color: #FF8510;
}
.red {
  background-color: #E42728;
}

.mark {
  border: 1px solid #cdcdcd;
  border-right: none;
  padding: 8px;
  line-height: 20px;
  text-align: center;
}
.mark:last-child {
  border-right: 1px solid #cdcdcd;
}

</style>
<style>

#popupRiskDecision > .vs-popup {
  width: 1167px !important;
}

#popupRiskDecision > .vs-popup > .vs-popup--content {
  width: 100%;
  padding: 0;
  margin: 0;
}

#popupRiskDecision > .vs-popup > .vs-popup--content > .vs-row {
  padding: 24px;

}

</style>
